import * as React from "react";
import { useTranslation } from "react-i18next";
import { useState, useEffect, useMemo } from "react";
import { RowTitleButton } from "common/components";
import usePluggableEntityTableElements from "hooks/usePluggableEntityTableElements";
import { useModalContext } from "common/contexts";
import DescriptionCell from "../DescriptionCell";
const TitleCell = ({ eventProcedure }) => {
  const { t } = useTranslation("enterprise_security_events");
  const [selectedProcedureId, setSelectedProcedureId] = useState(void 0);
  const { setModal, setEntity } = useModalContext();
  const onClickProcedure = () => {
    setSelectedProcedureId(eventProcedure.id);
    setEntity(eventProcedure);
    setModal("SHOW-EVENT-PROCEDURE-DETAILS");
  };
  useEffect(() => {
    if (eventProcedure.id === selectedProcedureId) setEntity(eventProcedure);
  }, [eventProcedure, selectedProcedureId, setEntity]);
  return /* @__PURE__ */ React.createElement(RowTitleButton, { onClick: onClickProcedure }, (eventProcedure == null ? void 0 : eventProcedure.title) || t("title_cell.no_title"));
};
export const useColumnRenderers = () => {
  const { pluggableColumnRenderers } = usePluggableEntityTableElements(
    null,
    "event_procedure"
  );
  const columnRenderers = useMemo(
    () => ({
      attributes: {
        title: {
          renderCell: (_, eventProcedure) => /* @__PURE__ */ React.createElement(TitleCell, { eventProcedure })
        },
        description: {
          renderCell: (_, eventProcedure) => /* @__PURE__ */ React.createElement(DescriptionCell, { mdValue: eventProcedure.description })
        },
        ...pluggableColumnRenderers
      }
    }),
    [pluggableColumnRenderers]
  );
  return { columnRenderers };
};
